(() => {
  const storageKey = 'maison-ketenci-saved-products';
  const sections = document.querySelectorAll('[data-saved-items-section]');
  if (!sections.length) return;

  const strings = (window.maisonMarket && window.maisonMarket.wishlistStrings) || {};
  const moneyFormat = (window.maisonMarket && window.maisonMarket.moneyFormat) || '${{amount}}';
  const rootUrl = ((window.maisonMarket && window.maisonMarket.rootUrl) || '/').replace(/\/?$/, '/');

  const heartIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.8a5.5 5.5 0 0 0-7.8 0L12 5.9l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.4a5.5 5.5 0 0 0 0-7.8Z"></path></svg>';

  const readSaved = () => {
    if (window.maisonSaved && typeof window.maisonSaved.getHandles === 'function') {
      return window.maisonSaved.getHandles();
    }
    try {
      const list = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (error) {
      return [];
    }
  };

  const writeSaved = (list) => {
    if (window.maisonSaved && typeof window.maisonSaved.replace === 'function') {
      window.maisonSaved.replace(list);
      return;
    }
    try {
      localStorage.setItem(storageKey, JSON.stringify(list));
    } catch (error) {
      // Storage can be blocked in private browsing.
    }
  };

  const updateBadge = (list) => {
    document.querySelectorAll('[data-saved-count]').forEach((badge) => {
      badge.textContent = String(list.length);
      badge.classList.toggle('is-hidden', list.length === 0);
    });
  };

  const formatMoney = (cents, format) => {
    const numericCents = Number(cents) || 0;
    const value = (numericCents / 100).toFixed(2);
    const [dollars, decimals] = value.split('.');
    const withCommas = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return String(format)
      .replace(/\{\{\s*amount\s*\}\}/g, `${withCommas}.${decimals}`)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, `${dollars.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${decimals}`)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, dollars.replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  };

  const escapeHtml = (value) => String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  const removeHandle = (handle) => {
    if (window.maisonSaved && typeof window.maisonSaved.remove === 'function') {
      window.maisonSaved.remove(handle);
      return window.maisonSaved.getHandles();
    }

    const list = readSaved().filter((item) => item !== handle);
    writeSaved(list);
    updateBadge(list);
    return list;
  };

  const productEndpoint = (handle) => `${rootUrl}products/${encodeURIComponent(handle)}.js`;

  const buildCard = (product, context) => {
    const article = document.createElement('article');
    article.className = 'product-card';
    article.dataset.productHandle = product.handle;
    article.setAttribute('role', 'listitem');

    const currentPrice = Number(product.price_min ?? product.price ?? 0);
    const compareAtPrice = Number(product.compare_at_price_max ?? 0);
    const discountPercent = compareAtPrice > currentPrice
      ? Math.round(((compareAtPrice - currentPrice) / compareAtPrice) * 100)
      : 0;

    let badge = '';
    if (!product.available) {
      badge = `<span class="badge">${escapeHtml(strings.soldOut || 'Sold out')}</span>`;
    } else if (discountPercent > 0) {
      badge = `<span class="badge badge--sale">${discountPercent}% ${escapeHtml(strings.off || 'off')}</span>`;
    } else if ((product.tags || []).some((tag) => /best.?seller/i.test(tag))) {
      badge = '<span class="badge badge--bestseller">Bestseller</span>';
    }

    const primaryImage = product.images && product.images[0];
    const secondaryImage = product.images && product.images[1];
    const media = primaryImage
      ? `<img class="product-card__image product-card__image--primary" src="${escapeHtml(primaryImage)}" alt="${escapeHtml(product.title)}" loading="lazy" width="600" height="600">${secondaryImage ? `<img class="product-card__image product-card__image--secondary" src="${escapeHtml(secondaryImage)}" alt="" loading="lazy" width="600" height="600">` : ''}`
      : '';

    const pricePrefix = product.price_varies ? `<span class="price-prefix">${escapeHtml(strings.from || 'From')} </span>` : '';
    const comparePrice = compareAtPrice > currentPrice
      ? `<span class="compare-price">${formatMoney(compareAtPrice, moneyFormat)}</span>`
      : '';
    const productUrl = product.url || `${rootUrl}products/${encodeURIComponent(product.handle)}`;

    article.innerHTML = `
      <a class="product-card__link" href="${escapeHtml(productUrl)}" aria-label="${escapeHtml(product.title)}">
        <div class="media-frame media-frame--square product-card__media">
          ${badge}
          ${media}
        </div>
        <div class="product-card__details">
          <h3>${escapeHtml(product.title)}</h3>
          <div class="product-card__price-row">
            <p class="price">${pricePrefix}${formatMoney(currentPrice, moneyFormat)}</p>
            ${comparePrice}
          </div>
        </div>
      </a>
      <button class="product-card__favorite is-saved" type="button" data-remove-saved aria-label="${escapeHtml(strings.remove || 'Remove from saved')}" aria-pressed="true">
        ${heartIcon}
        <span class="visually-hidden">${escapeHtml(strings.remove || 'Remove from saved')}</span>
      </button>
    `;

    article.querySelector('[data-remove-saved]').addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      article.classList.add('is-removing');
      const list = removeHandle(product.handle);
      window.setTimeout(() => {
        article.remove();
        if (list.length === 0) {
          context.gridEl.classList.add('is-hidden');
          context.emptyEl.classList.remove('is-hidden');
        }
      }, 180);
    });

    return article;
  };

  const renderSection = async (section) => {
    const loadingEl = section.querySelector('[data-saved-items-loading]');
    const emptyEl = section.querySelector('[data-saved-items-empty]');
    const gridEl = section.querySelector('[data-saved-items-grid]');
    if (!loadingEl || !emptyEl || !gridEl) return;

    const handles = readSaved();
    updateBadge(handles);
    gridEl.replaceChildren();
    emptyEl.classList.add('is-hidden');
    loadingEl.classList.remove('is-hidden');

    if (handles.length === 0) {
      loadingEl.classList.add('is-hidden');
      gridEl.classList.add('is-hidden');
      emptyEl.classList.remove('is-hidden');
      return;
    }

    const results = await Promise.all(handles.map(async (handle) => {
      try {
        const response = await fetch(productEndpoint(handle), { credentials: 'same-origin' });
        if (!response.ok) return null;
        return await response.json();
      } catch (error) {
        return null;
      }
    }));

    const validHandles = [];
    const products = [];
    results.forEach((product, index) => {
      if (product) {
        products.push(product);
        validHandles.push(handles[index]);
      }
    });

    if (validHandles.length !== handles.length) {
      writeSaved(validHandles);
      updateBadge(validHandles);
    }

    loadingEl.classList.add('is-hidden');

    if (products.length === 0) {
      gridEl.classList.add('is-hidden');
      emptyEl.classList.remove('is-hidden');
      return;
    }

    const fragment = document.createDocumentFragment();
    const context = { gridEl, emptyEl };
    products.forEach((product) => fragment.appendChild(buildCard(product, context)));
    gridEl.appendChild(fragment);
    gridEl.classList.remove('is-hidden');
  };

  const renderAll = () => sections.forEach(renderSection);

  document.addEventListener('maison:wishlist-change', () => {
    // On the wishlist page, reflect removals/additions immediately without a refresh.
    renderAll();
  });

  renderAll();
})();
